webpackJsonp([35783957827783],{

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/home-alive-calling.3ef12525.png";

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/home1.31992a84.jpg";

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/home10.120a139f.png";

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/home11.0893c38e.png";

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/home7.4b627464.png";

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/home8.0b21745f.png";

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ifgf-austin-tag1.97b81eff.jpg";

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\nfont-size: 40px;\ntext-align:right;\ntext-transform: uppercase;\nwhite-space:nowrap;\n'], ['\nfont-size: 40px;\ntext-align:right;\ntext-transform: uppercase;\nwhite-space:nowrap;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\nfont-size: 32px;\ntext-transform: uppercase;\n'], ['\nfont-size: 32px;\ntext-transform: uppercase;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\nfont-size: 18px;\n'], ['\nfont-size: 18px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactParallax = __webpack_require__(6);
	
	var _get2 = __webpack_require__(89);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _reactstrap = __webpack_require__(5);
	
	var _homeAliveCalling = __webpack_require__(481);
	
	var _homeAliveCalling2 = _interopRequireDefault(_homeAliveCalling);
	
	var _home = __webpack_require__(483);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _home3 = __webpack_require__(484);
	
	var _home4 = _interopRequireDefault(_home3);
	
	var _home5 = __webpack_require__(482);
	
	var _home6 = _interopRequireDefault(_home5);
	
	var _home7 = __webpack_require__(485);
	
	var _home8 = _interopRequireDefault(_home7);
	
	var _home9 = __webpack_require__(486);
	
	var _home10 = _interopRequireDefault(_home9);
	
	var _ifgfAustinTag = __webpack_require__(487);
	
	var _ifgfAustinTag2 = _interopRequireDefault(_ifgfAustinTag);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactSocialIcons = __webpack_require__(70);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var CampusText = _styledComponents2.default.div(_templateObject);
	
	var HeadlineHeadText = _styledComponents2.default.div(_templateObject2);
	
	var HomeText = _styledComponents2.default.div(_templateObject3);
	
	var items = [{
	  src: _homeAliveCalling2.default,
	  altText: '',
	  caption: ''
	}, {
	  src: _home2.default,
	  altText: '',
	  caption: ''
	
	}, {
	  src: _home4.default,
	  altText: '',
	  caption: ''
	
	}, {
	  src: _home6.default,
	  altText: '',
	  caption: ''
	
	}, {
	  src: _home10.default,
	  altText: '',
	  caption: ''
	
	}, {
	  src: _ifgfAustinTag2.default,
	  altText: '',
	  caption: ''
	}];
	
	var RootIndex = function (_Component) {
	  _inherits(RootIndex, _Component);
	
	  function RootIndex(props) {
	    _classCallCheck(this, RootIndex);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = { activeIndex: 0 };
	    _this.next = _this.next.bind(_this);
	    _this.previous = _this.previous.bind(_this);
	    _this.goToIndex = _this.goToIndex.bind(_this);
	    _this.onExiting = _this.onExiting.bind(_this);
	    _this.onExited = _this.onExited.bind(_this);
	
	    _this.announcementModuleShow = false;
	    _this.announcementModuleStartDate = new Date();
	    _this.announcementModuleEndDate = new Date();
	
	    return _this;
	  }
	
	  RootIndex.prototype.componentDidMount = function componentDidMount() {
	    //debugger;
	    var _datetime = new Date();
	    var _startDate = new Date(this.announcementModuleStartDate);
	    var _endDate = new Date(this.announcementModuleEndDate);
	
	    if (this.announcementModuleShow && _datetime >= _startDate && _datetime <= _endDate) {
	      document.getElementById('divAnnouncement').style.display = 'block';
	    } else {
	      document.getElementById('divAnnouncement').style.display = 'none';
	    }
	
	    /*
	          if (_datetime > new Date("04/18/2021 15:00:00") && _datetime < new Date("05/02/2021 15:00:00") ) 
	          {
	            document.getElementById('reserve0502').style.display='block';
	          }
	    
	          if (_datetime > new Date("04/25/2021 15:00:00") && _datetime < new Date("05/09/2021 15:00:00") ) 
	          {
	            document.getElementById('reserve0509').style.display='block';
	          }
	    
	          if (_datetime > new Date("05/02/2021 15:00:00") && _datetime < new Date("05/16/2021 15:00:00") ) 
	          {
	            document.getElementById('reserve0516').style.display='block';
	          }
	    
	          if (_datetime > new Date("05/09/2021 15:00:00") && _datetime < new Date("05/23/2021 15:00:00") ) 
	          {
	            document.getElementById('reserve0523').style.display='block';
	          }
	    
	          if (_datetime > new Date("05/16/2021 15:00:00") && _datetime < new Date("05/30/2021 15:00:00") ) 
	          {
	            document.getElementById('reserve0530').style.display='block';
	          }
	    
	          if (_datetime > new Date("05/23/2021 15:00:00") && _datetime < new Date("06/06/2021 15:00:00") ) 
	          {
	            document.getElementById('reserve0606').style.display='block';
	          }
	    
	          if (_datetime > new Date("05/30/2021 15:00:00") && _datetime < new Date("06/13/2021 15:00:00") ) 
	          {
	            document.getElementById('reserve0613').style.display='block';
	          }
	    
	          if (_datetime > new Date("06/06/2021 15:00:00") && _datetime < new Date("06/20/2021 15:00:00") ) 
	          {
	            document.getElementById('reserve0620').style.display='block';
	          }
	    
	          if (_datetime > new Date("06/13/2021 15:00:00") && _datetime < new Date("06/27/2021 15:00:00") ) 
	          {
	            document.getElementById('reserve0627').style.display='block';
	          }
	    
	          if (_datetime > new Date("06/20/2021 15:00:00") && _datetime < new Date("07/04/2021 15:00:00") ) 
	          {
	            document.getElementById('reserve0704').style.display='block';
	          }
	    
	          if (_datetime > new Date("06/27/2021 15:00:00") && _datetime < new Date("07/11/2021 15:00:00") ) 
	          {
	            document.getElementById('reserve0711').style.display='block';
	          }
	    
	          if (_datetime > new Date("07/04/2021 15:00:00") && _datetime < new Date("07/18/2021 15:00:00") ) 
	          {
	            document.getElementById('reserve0718').style.display='block';
	          }
	          
	          if (_datetime > new Date("07/11/2021 15:00:00") && _datetime < new Date("07/25/2021 15:00:00") ) 
	          {
	            document.getElementById('reserve0725').style.display='block';
	          }
	          
	    */
	  };
	
	  RootIndex.prototype.onExiting = function onExiting() {
	    this.animating = true;
	  };
	
	  RootIndex.prototype.onExited = function onExited() {
	    this.animating = false;
	  };
	
	  RootIndex.prototype.next = function next() {
	    if (this.animating) return;
	    var nextIndex = this.state.activeIndex === items.length - 1 ? 0 : this.state.activeIndex + 1;
	    this.setState({ activeIndex: nextIndex });
	  };
	
	  RootIndex.prototype.previous = function previous() {
	    if (this.animating) return;
	    var nextIndex = this.state.activeIndex === 0 ? items.length - 1 : this.state.activeIndex - 1;
	    this.setState({ activeIndex: nextIndex });
	  };
	
	  RootIndex.prototype.goToIndex = function goToIndex(newIndex) {
	    if (this.animating) return;
	    this.setState({ activeIndex: newIndex });
	  };
	
	  RootIndex.prototype.render = function render() {
	    var _this2 = this;
	
	    /*
	    //Sample to send variable during Gatsby's rendering.
	    const ShowFlag = (showFlag,startDate,endDate) => {
	      var _startDate = new Date(startDate);
	      var _endDate = new Date(endDate);
	      var _datetime = new Date();
	      
	      return (
	        ( showFlag
	          &&_datetime >= _startDate 
	          && _datetime <= _endDate
	          ) 
	      );
	    }
	    */
	
	    var activeIndex = this.state.activeIndex;
	
	    var _get = (0, _get3.default)(this, 'props.data.allContentfulModule.edges'),
	        announcementModuleObj = _get[0];
	
	    var upcomingEvents = (0, _get3.default)(this, 'props.data.allContentfulUpcomingEvents.edges');
	    var linkurl;
	
	    //Setting the property of the announcement Module to the client.
	    if (announcementModuleObj.node.show) {
	      this.announcementModuleShow = true;
	    } else {
	      this.announcementModuleShow = false;
	    }
	    this.announcementModuleShow = announcementModuleObj.node.show;
	    this.announcementModuleStartDate = announcementModuleObj.node.startDate;
	    this.announcementModuleEndDate = announcementModuleObj.node.endDate;
	
	    var slides = items.map(function (item) {
	      return _react2.default.createElement(
	        _reactstrap.CarouselItem,
	        {
	          onExiting: _this2.onExiting,
	          onExited: _this2.onExited,
	          key: item.src
	        },
	        _react2.default.createElement('img', { src: item.src, alt: item.altText }),
	        _react2.default.createElement(_reactstrap.CarouselCaption, { captionHeader: item.caption, captionText: '' })
	      );
	    });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactstrap.Container,
	        { style: { background: 'white', maxWidth: 1200, margin: 'auto', padding: '0px' } },
	        _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { sm: '12' },
	            _react2.default.createElement(
	              _reactstrap.Carousel,
	              {
	                activeIndex: activeIndex,
	                next: this.next,
	                previous: this.previous
	              },
	              _react2.default.createElement(_reactstrap.CarouselIndicators, { items: items, activeIndex: activeIndex, onClickHandler: this.goToIndex }),
	              slides,
	              _react2.default.createElement(_reactstrap.CarouselControl, { direction: 'prev', directionText: 'Previous', onClickHandler: this.previous }),
	              _react2.default.createElement(_reactstrap.CarouselControl, { direction: 'next', directionText: 'Next', onClickHandler: this.next })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { sm: '12', style: { textAlign: 'center' } },
	            'To be a ',
	            _react2.default.createElement(
	              'i',
	              null,
	              _react2.default.createElement(
	                'b',
	                null,
	                'MULTI-ETHNIC'
	              )
	            ),
	            ' church where all people find it ',
	            _react2.default.createElement(
	              'i',
	              null,
	              _react2.default.createElement(
	                'b',
	                null,
	                'IRRESISTIBLE'
	              )
	            ),
	            ', ',
	            _react2.default.createElement(
	              'i',
	              null,
	              _react2.default.createElement(
	                'b',
	                null,
	                'ENGAGING'
	              )
	            ),
	            ' and ',
	            _react2.default.createElement(
	              'i',
	              null,
	              _react2.default.createElement(
	                'b',
	                null,
	                'IMPACTFUL'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Row,
	          { style: { paddingTop: 50, paddingLeft: 50, paddingRight: 50 } },
	          _react2.default.createElement(
	            _reactstrap.Col,
	            null,
	            _react2.default.createElement(
	              'h2',
	              null,
	              'IFGF Austin In-person Worship'
	            ),
	            _react2.default.createElement(
	              'b',
	              null,
	              'Every Sunday 10.30AM'
	            ),
	            _react2.default.createElement('p', null)
	          ),
	          _react2.default.createElement(
	            _reactstrap.Col,
	            null,
	            _react2.default.createElement(
	              'h2',
	              null,
	              'IFGF Austin Online'
	            ),
	            _react2.default.createElement(
	              'b',
	              null,
	              'Every Sunday 10.30AM'
	            ),
	            _react2.default.createElement('p', null)
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Row,
	          { style: { paddingLeft: 50, paddingRight: 50, height: 100 } },
	          _react2.default.createElement(
	            _reactstrap.Col,
	            null,
	            _react2.default.createElement(
	              'div',
	              { id: 'reservenomore', style: { display: 'none' } },
	              'RSVP is no longer required (Face Mask is required) for attending our weekly worship service.',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('br', null)
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'reserve0620', style: { display: 'none' } },
	              _react2.default.createElement('p', null),
	              _react2.default.createElement(
	                'b',
	                null,
	                ' Father\'s Day (June 20th) In-person Worship'
	              ),
	              _react2.default.createElement('br', null),
	              ' ',
	              _react2.default.createElement(
	                'button',
	                { style: { color: '#ffffff', backgroundColor: '#ff6600' }, id: 'btn-rsvp-0620', type: 'button' },
	                'RSVP for Father\'s Day (June 20th)'
	              ),
	              _react2.default.createElement('p', null),
	              _react2.default.createElement('hr', null)
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'reserve0502', style: { display: 'none' } },
	              _react2.default.createElement('p', null),
	              _react2.default.createElement(
	                'b',
	                null,
	                ' May 2nd In-person Worship'
	              ),
	              _react2.default.createElement('br', null),
	              ' ',
	              _react2.default.createElement(
	                'button',
	                { style: { color: '#ffffff', backgroundColor: '#ff6600' }, id: 'btn-rsvp-0502', type: 'button' },
	                'RSVP for May 2nd'
	              ),
	              _react2.default.createElement('p', null),
	              _react2.default.createElement('hr', null)
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'reserve0516', style: { display: 'none' } },
	              _react2.default.createElement('p', null),
	              _react2.default.createElement(
	                'b',
	                null,
	                ' May 16th In-person Worship'
	              ),
	              _react2.default.createElement('br', null),
	              ' ',
	              _react2.default.createElement(
	                'button',
	                { style: { color: '#ffffff', backgroundColor: '#ff6600' }, id: 'btn-rsvp-0516', type: 'button' },
	                'RSVP for May 16th'
	              ),
	              _react2.default.createElement('p', null),
	              _react2.default.createElement('hr', null)
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'reserve0523', style: { display: 'none' } },
	              _react2.default.createElement('p', null),
	              _react2.default.createElement(
	                'b',
	                null,
	                ' May 23rd In-person Worship'
	              ),
	              _react2.default.createElement('br', null),
	              ' ',
	              _react2.default.createElement(
	                'button',
	                { style: { color: '#ffffff', backgroundColor: '#ff6600' }, id: 'btn-rsvp-0523', type: 'button' },
	                'RSVP for May 23rd'
	              ),
	              _react2.default.createElement('p', null),
	              _react2.default.createElement('hr', null)
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'reserve0530', style: { display: 'none' } },
	              _react2.default.createElement('p', null),
	              _react2.default.createElement(
	                'b',
	                null,
	                ' May 30th In-person Worship'
	              ),
	              _react2.default.createElement('br', null),
	              ' ',
	              _react2.default.createElement(
	                'button',
	                { style: { color: '#ffffff', backgroundColor: '#ff6600' }, id: 'btn-rsvp-0530', type: 'button' },
	                'RSVP for May 30th'
	              ),
	              _react2.default.createElement('p', null),
	              _react2.default.createElement('hr', null)
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'reserve0606', style: { display: 'none' } },
	              _react2.default.createElement('p', null),
	              _react2.default.createElement(
	                'b',
	                null,
	                ' June 6th In-person Worship'
	              ),
	              _react2.default.createElement('br', null),
	              ' ',
	              _react2.default.createElement(
	                'button',
	                { style: { color: '#ffffff', backgroundColor: '#ff6600' }, id: 'btn-rsvp-0606', type: 'button' },
	                'RSVP for June 6th'
	              ),
	              _react2.default.createElement('p', null),
	              _react2.default.createElement('hr', null)
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'reserve0613', style: { display: 'none' } },
	              _react2.default.createElement('p', null),
	              _react2.default.createElement(
	                'b',
	                null,
	                ' June 13th In-person Worship'
	              ),
	              _react2.default.createElement('br', null),
	              ' ',
	              _react2.default.createElement(
	                'button',
	                { style: { color: '#ffffff', backgroundColor: '#ff6600' }, id: 'btn-rsvp-0613', type: 'button' },
	                'RSVP for June 13th'
	              ),
	              _react2.default.createElement('p', null),
	              _react2.default.createElement('hr', null)
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'reserve0627', style: { display: 'none' } },
	              _react2.default.createElement('p', null),
	              _react2.default.createElement(
	                'b',
	                null,
	                ' June 27th In-person Worship'
	              ),
	              _react2.default.createElement('br', null),
	              ' ',
	              _react2.default.createElement(
	                'button',
	                { style: { color: '#ffffff', backgroundColor: '#ff6600' }, id: 'btn-rsvp-0627', type: 'button' },
	                'RSVP for June 27th'
	              ),
	              _react2.default.createElement('p', null),
	              _react2.default.createElement('hr', null)
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'reserve0704', style: { display: 'none' } },
	              _react2.default.createElement('p', null),
	              _react2.default.createElement(
	                'b',
	                null,
	                ' July 4th In-person Worship'
	              ),
	              _react2.default.createElement('br', null),
	              ' ',
	              _react2.default.createElement(
	                'button',
	                { style: { color: '#ffffff', backgroundColor: '#ff6600' }, id: 'btn-rsvp-0704', type: 'button' },
	                'RSVP for July 4th'
	              ),
	              _react2.default.createElement('p', null),
	              _react2.default.createElement('hr', null)
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'reserve0711', style: { display: 'none' } },
	              _react2.default.createElement('p', null),
	              _react2.default.createElement(
	                'b',
	                null,
	                ' July 11th In-person Worship'
	              ),
	              _react2.default.createElement('br', null),
	              ' ',
	              _react2.default.createElement(
	                'button',
	                { style: { color: '#ffffff', backgroundColor: '#ff6600' }, id: 'btn-rsvp-0711', type: 'button' },
	                'RSVP for July 11th'
	              ),
	              _react2.default.createElement('p', null),
	              _react2.default.createElement('hr', null)
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'reserve0718', style: { display: 'none' } },
	              _react2.default.createElement('p', null),
	              _react2.default.createElement(
	                'b',
	                null,
	                ' July 18th In-person Worship'
	              ),
	              _react2.default.createElement('br', null),
	              ' ',
	              _react2.default.createElement(
	                'button',
	                { style: { color: '#ffffff', backgroundColor: '#ff6600' }, id: 'btn-rsvp-0718', type: 'button' },
	                'RSVP for July 18th'
	              ),
	              _react2.default.createElement('p', null),
	              _react2.default.createElement('hr', null)
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'reserve0725', style: { display: 'none' } },
	              _react2.default.createElement('p', null),
	              _react2.default.createElement(
	                'b',
	                null,
	                ' July 25th In-person Worship'
	              ),
	              _react2.default.createElement('br', null),
	              ' ',
	              _react2.default.createElement(
	                'button',
	                { style: { color: '#ffffff', backgroundColor: '#ff6600' }, id: 'btn-rsvp-0725', type: 'button' },
	                'RSVP for July 25th'
	              ),
	              _react2.default.createElement('p', null),
	              _react2.default.createElement('hr', null)
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Col,
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.youtube.com/channel/UCdgH27j2WrfL5oeiqEWKwOw/live', target: '_new' },
	              'YouTube'
	            ),
	            '\xA0\xA0 | ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.facebook.com/ifgfaustin', target: '_new' },
	              'Facebook'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            null,
	            _react2.default.createElement(
	              'div',
	              { id: 'divAnnouncement' },
	              _react2.default.createElement(
	                HeadlineHeadText,
	                null,
	                announcementModuleObj.node.frontlineHeadline
	              ),
	              _react2.default.createElement('hr', { className: 'my-2' }),
	              _react2.default.createElement('div', {
	                dangerouslySetInnerHTML: { __html: announcementModuleObj.node.childContentfulModuleContentTextNode.childMarkdownRemark.html }
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { sm: '5' },
	            _react2.default.createElement(
	              CampusText,
	              null,
	              'Austin',
	              _react2.default.createElement('br', null),
	              'San Antonio',
	              _react2.default.createElement('br', null),
	              'St. Louis'
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { sm: '7' },
	            _react2.default.createElement(
	              HomeText,
	              null,
	              'International Full Gospel Fellowship (IFGF) is an Apostolic Denomination church which is concerned with reaching the lost and ministering outside the four wall of the church. We aimed to bring an impact to the communities, cities and nations using many means, such as church planting, humanitarian and compassion ministries, prayer, community development, and education.',
	              _react2.default.createElement('p', null),
	              'The word \u201Capostle\u201D has been used to describe variety of things. The earliest mention of \u201Capostle\u201D were to describe Jesus\u2019 disciples (Mat 10:2-4).',
	              _react2.default.createElement(
	                'p',
	                { style: { textAlign: "right", paddingRight: '30px' } },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/about-ifgf/', style: { color: "red" } },
	                  '>>read more'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _reactstrap.Container,
	        { style: { background: 'white', maxWidth: 1200, margin: '0 auto', padding: '0px' } },
	        _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            null,
	            _react2.default.createElement(
	              'div',
	              { style: { padding: 20 } },
	              _react2.default.createElement(
	                HeadlineHeadText,
	                null,
	                'Upcoming Events'
	              ),
	              _react2.default.createElement('hr', { className: 'my-2' }),
	              _react2.default.createElement(
	                'ul',
	                { className: 'upcomingeventsfront-list' },
	                upcomingEvents.map(function (_ref) {
	                  var node = _ref.node;
	
	                  if (node.header == null || Date.parse(node.expiredDate) <= new Date()) {
	                    return "";
	                  } else {
	
	                    return _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        node.eventDate
	                      ),
	                      _react2.default.createElement('br', null),
	                      _react2.default.createElement(
	                        'b',
	                        { className: 'blue' },
	                        node.header
	                      ),
	                      _react2.default.createElement('br', null),
	                      _react2.default.createElement('div', { style: { width: '70%', display: 'inline-block' },
	                        dangerouslySetInnerHTML: { __html: node.frontPageDescription.childMarkdownRemark.html }
	                      })
	                    );
	                  }
	                })
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return RootIndex;
	}(_react.Component);
	
	exports.default = RootIndex;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-0a4b5bf47f1da81332e1.js